<!-- Department header -->
<app-dept-header></app-dept-header>
<!-- Department header -->
<div id="page-content" *ngFor="let dept of deptData" class="page-microsite">
  <!-- Slider -->
  <div id="slider" [ngStyle]="setMyStyles()">
    <div class="container">
      <div class="slider-wrapper">
        <div class="row">
          <div class="col-md-9 col-sm-12">
            <div class="wow fadeInLeft animated">
              <div class="row">
                  <!-- <div class="image-carousel">-->
                        <div class="col-md-4 col-sm-4 microsit-head">
                          <h2>{{dept.dept_name}}</h2>
                          <p>
                            {{dept.short_desc}}
                          </p>
      <!--                    <a href="#" class="btn btn-small btn-color-white">View Details</a>-->
                        </div><!-- /.col-md-4 -->
                    <div class="col-md-8">
                      <ngb-carousel>
                        <ng-template ngbSlide *ngFor="let slide of slidesData">
                          <div class="picsum-img-wrapper">
                            <img src="{{slide.image}}" alt="{{slide.title}}">
                          </div>
                        </ng-template>
                      </ngb-carousel>
                    </div>
              </div><!-- /.row -->
            </div>
          </div><!-- /.col-md-9 -->

          <div class="col-md-3 col-sm-12">
            <div class="wow fadeInRight animated">
              <aside class="news-small" id="news-slider">
                <header>
                  <h2>Latest News</h2>
                </header>
                <div *ngIf="newsData.length == 0">
                  <p>No Latest News...</p>
                </div>
                <div class="section-content">
                  <article *ngFor="let news of newsData.slice(0, 2) let i=index">
                    <header><i class="fa fa-file-o"></i>
                      <a routerLink="/info/{{news.id}}">
                        {{news.title | slice:0:60}}...
                      </a>
                    </header>
                  </article><!-- /article -->
                </div><!-- /.section-content -->
                <a routerLink="/allnews/{{deptId}}/1" class="read-more">All News</a>
              </aside><!-- /.news-small -->
            </div>
          </div><!-- /.col-md-3 -->

        </div><!-- /.row -->
      </div><!-- /.slider-wrapper -->
    </div><!-- /.container -->
  </div>
  <!-- end Slider -->

  <!-- Content -->
  <div class="block">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <section class="events small" id="events-small">
            <header>
              <h2>Events</h2>
              <a href="" class="link-calendar">Calendar</a>
              <div *ngIf="eventsData.length == 0">
                <p>No Events...</p>
              </div>
            </header>
            <div class="section-content" *ngFor="let event of eventsData.slice(0, 3) let i=index">
              <article class="event nearest">
                <a routerLink="/info/{{event.id}}">
                  <figure class="date {{eventColor+(i+1)}}">
                    <div class="month">{{ event.commence_date | date:'MMMM' }}</div>
                    <div class="day">{{ event.commence_date | date:'d' }}</div>
                  </figure>
                </a>
                <aside>
                  <header>
                    <a routerLink="/info/{{event.id}}">
                      {{event.title | slice:0:60}}
                    </a>
                  </header>
                 <div class="additional-info">{{event.short_desc | slice:0:60}}..</div>
                </aside>
              </article><!-- /article -->
            </div><!-- /.section-content -->
            <a routerLink="/allinfo/{{deptId}}/2" class="read-more">All Events</a>
          </section><!-- /.information-small -->
        </div><!-- /.col-md-3 -->

        <div class="col-md-6">
          <section id="main-content">
            <header>
<!--              <h2>Welcome...</h2>-->
            </header>
            <div class="section-content">
              <div [innerHTML]="dept.long_desc"></div>
              <hr>
            </div><!-- /.section-content -->
          </section><!-- /.main-content -->
        </div><!-- /.col-md-6 -->

        <div class="col-md-3">
          <div *ngIf="linksData?.length != 0">
            <strong>Important Links</strong>
            <div>
              <span *ngFor="let link of linksData">
                <span *ngIf="link.link_type.type=='EXTERNAL_WEB'">
                    <a href="{{link.link_url}}" target="_blank">
                    <i *ngIf="link.link_type.type=='EXTERNAL_WEB'" class="fa fa-globe link-icon-size" aria-hidden="true"></i>
                    {{link.link_text}}<br>
                  </a>
                </span>
              </span>
              <hr>
            </div>
          </div>

          <section class="news-small" id="news-small">
            <header>
              <h3>Student notices</h3>
            </header>
            <div *ngIf="studentNoticeData.length == 0">
              <p>No Notices...</p>
            </div>
            <div class="section-content" *ngFor="let notice of studentNoticeData.slice(0, 8) let i=index">
              <article>
                <figure class="date"><i class="fa fa-file-o"></i>{{ notice.created_at | date:'MMMM d, y' }}</figure>
                <header>
                  <a routerLink="/info/{{notice.id}}">
                    {{notice.title}}
                  </a>
                </header>
              </article><!-- /article -->
            </div><!-- /.section-content -->
            <a routerLink="/otherinfo/{{deptId}}/3" class="read-more">All Notices</a>
          </section><!-- /.news-small -->

          <br>

          <div *ngIf="newsLetterData.length != 0">
            <section id="rasas" *ngFor="let newslet of newsLetterData.slice(0,2) let i=index">
              <header>
                <h5>
                  <a routerLink="/info/{{newslet.id}}">{{newslet.title}}</a>
                </h5>
              </header>
              <div class="section-content">
                <a routerLink="/info/{{newslet.id}}">
                  <img src="{{newslet.images}}" alt="" class="add-margin conf_image">
                </a>
              </div><!-- /.section-content -->
            </section><!-- /.about -->
            <div *ngIf="newsLetterData.length != 0">
              <a routerLink="/otherinfo/{{deptId}}/9" class="read-more">All Newsletters</a>
            </div>
          </div>
          <hr>
          <div>
              <span *ngIf="dept.url !== null && dept.url !== 'null'">
                <!--show all the youtube videos-->
                <div *ngFor="let youtube of youtubeUrls">
                  <iframe width="255px" height="180px" [src]='youtube | youtube' allowfullscreen></iframe>
                  <hr>
                </div>
              </span>
          </div>

        </div><!-- /.col-md-3 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <!-- end Content -->
</div>

<!-- Divisions, Connect -->
<div class="block">
  <div class="container">
    <div class="block-dark-background">
      <div class="row" *ngFor="let dept of deptData">
        <div class="col-lg-3 col-sm-4">
          <section id="division">
            <header>
              <h2>Contact</h2>
            </header>
            <div class="section-content">
              <p>
                {{dept.add_line1}}, {{dept.add_line2}}<br>
                {{dept.city}}<br>
                {{dept.postal_code}}<br>
                {{dept.country}}<br><br>

                Phone : {{dept.phone}} | {{dept.extensions}}<br>
                Fax : {{dept.fax}}<br>
                Email : {{dept.email}}<br>
              </p>
            </div><!-- /.section-content -->
          </section><!-- #.divisions -->
        </div>
        <div class="col-lg-9 col-sm-8">
          <section id="connect" *ngFor="let heads of headMessageData">
            <div class="connect-block">
              <div class="row">
                <div class="col-md-3">
                  <div class="card">
                    <img class="card-img-top" src="{{heads.images}}" alt="Card image cap">
                    <div class="card-body">
                      <h5 class="card-title">{{heads.title}}</h5>
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <article class="social-post facebook-post">
                      <header class="head-msg-header">
                        <div [innerHTML]="heads.short_desc"></div>
                      </header>

                      <div [innerHTML]="heads.long_desc" class="head-msg">

                      </div>
                    </article><!-- /.twitter-post -->
                  </div>
                </div>
              </div><!-- /.row -->
            </div><!-- /.section-content -->
          </section><!-- #.divisions -->
        </div><!-- /.col-md-9 -->
      </div><!-- /.row -->
    </div><!-- /.block-dark-background -->
  </div><!-- /.container -->
</div>
<!-- end Divisions, Connect -->

<!-- Page Content -->
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-12">
        <div id="page-main">
          <section class="blog-listing" id="blog-listing">
            <header *ngIf="degreeData.length !== 0"><h1>Degree Programmes/Courses</h1></header>
            <div class="row">

              <div class="col-md-4 col-sm-4" *ngFor="let degree of degreeData">
                <article class="blog-listing-post">
                  <figure class="blog-thumbnail">
                    <figure class="blog-meta"><span class="fa fa-file-text-o"></span>{{degree.deg_syllabus_type.syllabus_type}}</figure>
                    <div class="image-wrapper"><a routerLink="/degreedet/{{degree.id}}"><img src="{{degree.image}}"></a></div>
                  </figure>
                  <aside>
                    <header>
                      <a routerLink="/degreedet/{{degree.id}}"><h3>{{degree.degree_name}}</h3></a>
                    </header>
                    <div class="description">
<!--                      <p>{{degree.description}}</p>-->
                    </div>
<!--                    <a routerLink="#" (click)="navigatePage('degreedet',degree)" class="read-more stick-to-bottom">Read More</a>-->
                  </aside>
                </article><!-- /article -->
              </div><!-- /.col-md-6 -->

            </div><!-- /.row -->
          </section><!-- /.blog-listing -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
    </div>
  </div>


